import React, { FC } from "react"

import { FileTextOutlined } from "@ant-design/icons"
import { Button, Modal, Tooltip, Typography } from "antd"

import "./DescriptionPopover.scss"

const { Paragraph } = Typography

interface IDescriptionPopoverProps {
    description: string | null | undefined
}

const DescriptionPopover: FC<IDescriptionPopoverProps> = ({ description }) => {
    const [ isModalOpen, setIsModalOpen ] = React.useState(false)

    if (!description) {
        return null
    }

    const showModal = () => {
        setIsModalOpen(true)
    }

    const handleClose = () => {
        setIsModalOpen(false)
    }

    return (
        <>
            <Tooltip title="Описание">
                <Button
                    size="small"
                    icon={<FileTextOutlined />}
                    onClick={showModal}
                />
            </Tooltip>
            <Modal
                title="Описание объявления"
                open={isModalOpen}
                onCancel={handleClose}
                footer={null}
                width={600}
                className="description-modal"
            >
                <div className="description-content">
                    <Paragraph 
                        style={{ 
                            whiteSpace: "pre-wrap", 
                            marginBottom: 0,
                            maxHeight: "60vh",
                            overflow: "auto"
                        }}
                    >
                        {description}
                    </Paragraph>
                </div>
            </Modal>
        </>
    )
}

export default DescriptionPopover
